<mat-expansion-panel
  [disabled]="flujos.datosAdjuntos.bloqueado"
  hideToggle
  [expanded]="
    (flujos.configuracionProducto.ok || flujosPJ.formularioUAF.ok) &&
    !flujos.datosAdjuntos.ok &&
    !flujos.datosAdjuntos.cargando
  "
>
  <mat-expansion-panel-header>
    <mat-panel-title> Adjuntar documentos </mat-panel-title>
    <mat-panel-description>
      <div
        *ngIf="
          flujos.configuracionProducto.ok &&
          !flujos.datosAdjuntos.ok &&
          !flujos.datosAdjuntos.cargando
        "
      >
        <!--======informacion menu ======-->
        <ng-container *ngIf="documentsCount && showCantidadCampos">
          Adjunta {{ documentsCount }} {{documentsCount == 1 ? 'documento': 'documentos'}}
        </ng-container>
      </div>
      <div *ngIf="flujos.datosAdjuntos.cargando">
        <div class="spinner-border text-light" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div *ngIf="flujos.datosAdjuntos.ok && !flujos.datosAdjuntos.cargando">
        <!--======ok menu ======-->
        <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container
    *ngIf="!flujos.datosAdjuntos.cargando && flujos.datosAdjuntos.mostrar"
  >
    <div class="row">
      <form [formGroup]="form">
        <div class="col-md-12 doc-container" *ngIf="documentsConfig.ESCRITURA.show">
          <p class="titulo-dark-14">Acta de poderes o escritura o documento, que indique quienes son los socios(as) con poderes</p>
          <app-document-upload
            [control]="escrituraControl"
            [acceptedFormats]="documentsConfig.ESCRITURA.acceptedFormats"
            [maxFileBytes]="documentsConfig.ESCRITURA.maxFileSizeInBytes"
            [isLoading]="documentsConfig.ESCRITURA.isLoading"
            [isLoaded]="documentsConfig.ESCRITURA.isLoaded"
            [edicion]="edicion"
            [mb]="documentsConfig.ESCRITURA.mb"
            [corrupted]="documentsConfig.ESCRITURA.corrupted"
            [rest]="escrituraControlRest"
          >
          </app-document-upload>
        </div>

        <div class="col-md-12 doc-container" *ngIf="documentsConfig.FOTOGRAFIA_CEDULA.show">
          <p class="titulo-dark-14">Cédula de identidad por ambos lados</p>
          <app-document-upload
            [control]="fotoCedulaControl"
            [acceptedFormats]="
              documentsConfig.FOTOGRAFIA_CEDULA.acceptedFormats
            "
            [maxFileBytes]="
              documentsConfig.FOTOGRAFIA_CEDULA.maxFileSizeInBytes
            "
            [isLoading]="documentsConfig.FOTOGRAFIA_CEDULA.isLoading"
            [isLoaded]="documentsConfig.FOTOGRAFIA_CEDULA.isLoaded"
            [edicion]="edicion"
            [mb]="documentsConfig.FOTOGRAFIA_CEDULA.mb"
            [corrupted]="documentsConfig.FOTOGRAFIA_CEDULA.corrupted"
            [rest]="fotoCedulaControlRest"
          >
          </app-document-upload>
        </div>

        <div class="col-md-12 doc-container" *ngIf="documentsConfig.PATENTE_COMERCIAL.show">
          <p class="titulo-dark-14">Patente Comercial</p>
          <app-document-upload
            [control]="patenteComercialControl"
            [acceptedFormats]="
              documentsConfig.PATENTE_COMERCIAL.acceptedFormats
            "
            [maxFileBytes]="
              documentsConfig.PATENTE_COMERCIAL.maxFileSizeInBytes
            "
            [isLoading]="documentsConfig.PATENTE_COMERCIAL.isLoading"
            [isLoaded]="documentsConfig.PATENTE_COMERCIAL.isLoaded"
            [edicion]="edicion"
            [mb]="documentsConfig.PATENTE_COMERCIAL.mb"
            [corrupted]="documentsConfig.PATENTE_COMERCIAL.corrupted"
            [rest]="patenteComercialControlRest"
          >
          </app-document-upload>
        </div>

        <div class="col-md-12 doc-container" *ngIf="documentsConfig.BOLETA_O_FACTURA.show">
          <p class="titulo-dark-14">Boleta o Factura de Ventas de tu local</p>
          <app-document-upload
            [control]="boletaFacturaControl"
            [acceptedFormats]="documentsConfig.BOLETA_O_FACTURA.acceptedFormats"
            [maxFileBytes]="documentsConfig.BOLETA_O_FACTURA.maxFileSizeInBytes"
            [isLoading]="documentsConfig.BOLETA_O_FACTURA.isLoading"
            [isLoaded]="documentsConfig.BOLETA_O_FACTURA.isLoaded"
            [edicion]="edicion"
            [mb]="documentsConfig.BOLETA_O_FACTURA.mb"
            [corrupted]="documentsConfig.BOLETA_O_FACTURA.corrupted"
            [rest]="boletaFacturaControlRest"
          >
          </app-document-upload>
        </div>

        <div class="col-md-12 doc-container" *ngIf="documentsConfig.FERIAS_Y_EVENTOS.show">
          <p class="titulo-dark-14">Documento Feria y Evento</p>
          <app-document-upload
            [control]="feriasEventosControl"
            [acceptedFormats]="documentsConfig.FERIAS_Y_EVENTOS.acceptedFormats"
            [maxFileBytes]="documentsConfig.FERIAS_Y_EVENTOS.maxFileSizeInBytes"
            [isLoading]="documentsConfig.FERIAS_Y_EVENTOS.isLoading"
            [isLoaded]="documentsConfig.FERIAS_Y_EVENTOS.isLoaded"
            [edicion]="edicion"
            [mb]="documentsConfig.FERIAS_Y_EVENTOS.mb"
            [corrupted]="documentsConfig.FERIAS_Y_EVENTOS.corrupted"
            [rest]="feriasEventosControlRest"
          >
          </app-document-upload>
        </div>
        <div class="row box-button">
          <div class="col-md-6" 
              (click)="deleteDocuments()" 
              *ngIf="!edicion">
              <div class="col-md-6"
                *ngIf="loadingDelete"
                class="spinner-border text-light c-margen-spinner"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <div *ngIf="!loadingDelete" class="c-eliminar eliminardoc">Eliminar Documentos
              <div>
                <img class="c-icon" src="assets/icons/icon-delete.svg" alt="ok" />
             </div>
             </div>
          </div>
          <div class="col-md-6">  
            <button
              class="btn-primary-tbk"
              type="submit"
              value="ContinuarGuardar"
              (click)="ContinuarGuardar($event)"
              [disabled]="!validForm"
            >
            <div
                *ngIf="loading"
                class="spinner-border text-light"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <div *ngIf="!loading">Guardar</div>
           
            </button>
            </div>
          </div>
      </form>
    </div>
  </ng-container>
</mat-expansion-panel>
